<template>
    <div style="background: #f6f5fa;">
        <div class="md2018040302lty">
            <div class="container">
                <div class="banner-box clearfix">
                    <!--左侧菜单栏-->
                    <v-spin :spinning="loadingFlag" tip="正在读取数据." size="large" class="menu-con pull-left"
                        style="min-height: 500px;">
                        <ul class="menu-list" id="js_control_menu">
                            <li class="sub" v-for="(item,index) in workTypeList" :key="index"
                                @mouseover="mouseover(index)" @mouseleave="mouseleave(index)">
                                <a class="color-999" slot="reference">
                                    <span>{{item.workTypeName}}</span>
                                    <i class="verflag"></i>
                                    <i class="cusfont cusfont-more"></i></a>
                                <div class="item" @mouseover="mouseover(index)" @mouseleave="mouseleave(index)"
                                    :style="item.flag == true?'':'display: none'">
                                    <div class="course-list">
                                        <div class="course-item clearfix">
                                            <p><a @click="courseCenter()">{{item.workTypeName}}</a></p>
                                            <div class="c-l">
                                                <a v-for="(item2,index2) in item.courseHomePageList" :key="index2"
                                                    style="cursor: pointer;" class="abc"
                                                    @click="courseCenter()">{{item2.courseName}}
                                                </a>
                                                <i class="verflag"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <ul class="course-video clearfix bgcolor-fff" style="display: flex;">
                                        <li class="pull-left"><a target="_blank" style="display: flex;">
                                                <div class="l-p md-ad-imgbox">
                                                    <div class="course_img_min" @click="courseCenter()"
                                                        style="position: absolute;font-weight: bold;box-sizing: border-box;">
                                                        {{item.workTypeName}}
                                                    </div><img src="../../../static/img/courseBack.jpg" width="120"
                                                        height="68" alt="">
                                                </div>
                                                <div class="cv-r">
                                                    <h3 class="tit font-weight"
                                                        style="font-weight: bold;margin-left: 15px;"
                                                        @click="courseCenter()">
                                                        {{item.workTypeName}}</h3>
                                                </div>
                                            </a></li>
                                    </ul>
                                </div>
                            </li>
                            <li class="sub" @mouseover="mouseover1" @mouseleave="mouseleave1"><a href="#"
                                    class="color-999 "><span>其它工种</span><i class="verflag"></i><i
                                        class="cusfont cusfont-more"></i></a>
                                <div :style="flag1 == true?'':'display: none'" class="item" @mouseover="mouseover1"
                                    @mouseleave="mouseleave1" style="overflow-y: scroll;">
                                    <div class="course-list" style="height: 439px">
                                        <div class="course-item clearfix">
                                            <p><a @click="courseCenter()">其它工种</a></p>
                                            <div class="c-l">
                                                <a v-for="(item1,index1) in elseWorkTypeList" :key="index1"
                                                    @click="courseCenter()"
                                                    class="color-999">{{item1.workTypeName}}</a><i class="verflag"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </v-spin>
                    <!-- <div class="menu-con pull-left">
                    </div> -->
                    <!--右侧banner区-->
                    <!-- <div class="banner-con pull-left"> -->
                    <!--轮播区-->
                    <v-spin :spinning="loadingFlag1" tip="正在读取数据." size="large" class="banner-con pull-left"
                        style="min-height: 500px;border-bottom: 1px solid #1c252d;">
                        <div class="carousel-area" id="js_control_carousel" style="border-bottom: 1px solid #1c252d;">
                            <div class="hd">
                                <ul class="clearfix">
                                    <li class="on"></li>
                                </ul>
                            </div>
                            <div class="bd" style="height: 100%;">
                                <div class="tempWrap"
                                    style="overflow:hidden; position:relative;height: 100%; width:975px">
                                    <div class="tempWrap"
                                        style="overflow:hidden; position:relative;height: 100%; width:975px">
                                        <ul class="tempList"
                                            style="width: 975px; height: 100%; left: 0px; position: relative; overflow: hidden; padding: 0px; margin: 0px;">
                                            <el-carousel :interval="500000" arrow="always">
                                                <el-carousel-item v-for="(item,index) in slideshowList1" :key="index"
                                                    style="float: left; width: 975px;">
                                                    <li><img :src="item.src" style="width: 100%;"
                                                            @error="onerror(item)"></li>
                                                </el-carousel-item>
                                            </el-carousel>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--广告区-->
                        <div class="ad-area bgcolor-fff">
                            <ul class="ad-list clearfix">
                                <li style="display: flex;cursor: pointer;" @click="courseCenter()">
                                    <img src="http://cdn.tmooc.cn/bsfile//imgad///fff1186ad2ae4b0790825eae784cb041.jpg"
                                        width="32" height="32" alt="" class="pull-left">
                                    <div class="ad-r pull-right" style="margin-left: 10px;">
                                        <h3 class="font-14 color-333 text-overflow">课程专区</h3>
                                        <p class="color-888 text-overflow">VIP课程资源免费开放</p>
                                    </div>
                                </li>
                                <li style="display: flex;cursor: pointer;" @click="liveCenter()">
                                    <img src="http://cdn.tmooc.cn/bsfile//imgad///281d749e5acc4c7686ac76bd11589134.png"
                                        width="32" height="32" alt="" class="pull-left">
                                    <div class="ad-r pull-right" style="margin-left: 10px;">
                                        <h3 class="font-14 color-333 text-overflow">直播广场</h3>
                                        <p class="color-888 text-overflow">名师限时免费直播</p>
                                    </div>
                                </li>
                                <!-- <li style="display: flex;cursor: pointer;" @click="trainPlan()">
                                    <img src="http://cdn.tmooc.cn/bsfile//imgad///09a6c091745743779a469b1de82987be.png"
                                        width="32" height="32" alt="" class="pull-left">
                                    <div class="ad-r pull-right" style="margin-left: 10px;">
                                        <h3 class="font-14 color-333 text-overflow">图书推荐</h3>
                                        <p class="color-888 text-overflow">多重福利拿不停</p>
                                    </div>
                                </li>
                                <li style="display: flex;cursor: pointer;" @click="trainPlan()">
                                    <img src="http://cdn.tmooc.cn/bsfile//imgad///acf41aa9919c43628b1d06430f3367a7.png"
                                        width="32" height="32" alt="" class="pull-left">
                                    <div class="ad-r pull-right" style="margin-left: 10px;">
                                        <h3 class="font-14 color-333 text-overflow">新型学徒制</h3>
                                        <p class="color-888 text-overflow">优质好课超值专享</p>
                                    </div>
                                </li> -->
                            </ul>
                        </div>
                        <!-- </div> -->

                    </v-spin>
                </div>
            </div>
        </div>

        <div class="container" id="containerList">
            <div v-for="(item,index) in allWorkTypeList" :key="index" class="md-com-list"
                v-if="item.courseHomePageList.length>0">
                <div class="md-hd">
                    <div class="pull-left">
                        <img src="../../../static/img/workTypeCourse.png"
                            style="width: 27px;height: 27px;vertical-align: text-bottom;">
                        <span class="hd-tit color-333 font-20 verflag">{{item.workTypeName}}</span></div><a
                        class="font-14 pull-right color-999" @click="courseCenter(item.workTypeId)">查看更多&gt;&gt;</a>
                </div>
                <ul class="md-bd clearfix md-2018040201-lty" style="display: flex;">
                    <li class="pic-box  free" v-for="(item1,index1) in item.courseHomePageList" :key="index1" @click="courseDetail(item1,item.workTypeName)">
                        <div class="hd-pic" style="position: relative;"><a>
                                <div class="course_img" style="position: absolute;box-sizing: border-box;">
                                    {{item1.courseName}}</div><img src="../../../static/img/courseBack.jpg"><i
                                    class="state"></i>
                            </a>
                        </div>
                        <div class="bd-word bgcolor-fff">
                            <h4 class="bd-tit color-333"><a class="color-333"
                                    >【{{item.workTypeName}}】{{item1.courseName}}</a></h4>
                            <div class="clearfix">
                                <!-- <span class="price pull-left">￥{{item1.coursePrice}}</span> -->
                                <span class="sign-num pull-right color-888">{{item1.courseStudyNum}}人报名</span></div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="md2018040802lty">
        </div>

    </div>
</template>
<script>

    export default {
        name: 'app',
        components: {

        },
        data() {
            return {
                loadingFlag1: false,
                loadingFlag: false,
                flag1: false,
                workTypeList: [],
                elseWorkTypeList: [],
                allWorkTypeList: [],
                slideshowList1: []
            }
        },
        created() {
            this.$parent.leftBeginAffirm(0);
            //加载数据
            this.laodData();

            this.HandoverNotificationOrPresscenterDataLoad(29);
        },
        methods: {
            trainPlan() {
                this.$router.push({ path: '/trainingPlan' })
            },
            liveCenter() {
                this.$router.push({ path: '/liveClassroom' })
            },
            courseDetail(item,workTypeName) {
                this.$router.push({ path: '/courseBuyDetail/' + item.courseId + '/' + workTypeName})
            },
            courseCenter(workTypeId) {
                this.$router.push({ path: '/courseCenter/'+workTypeId });
            },
            onerror(item) {
                item.src = '../../static/img/peixunshouyemoren.jpg'
            },
            HandoverNotificationOrPresscenterDataLoad(navId) {
                this.loadingFlag1 = true;
                //加载 首页 数据  
                let parames = new URLSearchParams();
                parames.append('navId', navId); //id 类型id 
                parames.append('organStatus', this.organStatus);//  组织机构代码   1工大  2协会 3建投

                this.$axios.post(this.serverUrl + '/navList', parames).then(resp => {
                    if (resp.data.data.length > 0) {

                        let slideshowArrayList1 = [];
                        resp.data.data.forEach((element, index) => {
                            let index1 = index + 1;

                            if (this.flag) {
                                this.id = element.id;

                                this.navName = element.navName;
                                this.str = this.cutstr(element.contentDesc, 170);

                                this.contentTitle = element.contentTitle;

                                if (this.str.length != 0) {
                                    this.flag = false;
                                }
                            }
                            //轮播图 最多三条
                            if (index1 <= 3) {
                                let slideshowVo = {
                                    id: 0,
                                    navName: 0,
                                    src: '',
                                    contentTitle: '',
                                    insertTime: ''
                                }

                                slideshowVo.id = element.id;
                                slideshowVo.navName = element.navName;
                                slideshowVo.src = this.serverUrl + this.prefiexUrl + element.contentPic;
                                slideshowVo.contentTitle = element.contentTitle;

                                if (element.insertTime != null) {
                                    slideshowVo.insertTime = element.insertTime.substring(0, 10);
                                } else {
                                    slideshowVo.insertTime = '暂无';
                                }


                                slideshowArrayList1.push(slideshowVo);

                            }
                        })

                        this.slideshowList1 = slideshowArrayList1;

                        this.loadingFlag1 = false;
                    }

                }).catch(err => {
                    this.$message({
                        showClose: true,
                        message: '服务器繁忙,请稍后再试!',
                        type: 'error'
                    })
                })
            },
            laodData() {
                this.loadingFlag = true;
                //let parames = new URLSearchParams();
                this.$axios.post(this.serverUrl + '/el/selectWorkTypeCourseHomePage', {}).then(resp => {

                    for (let i = 0; i < resp.data.data.length; i++) {
                        if (i < 7) {
                            resp.data.data[i].flag = false;
                            this.workTypeList.push(resp.data.data[i]);
                        } else {
                            this.elseWorkTypeList.push(resp.data.data[i]);
                        }

                        resp.data.data[i].courseHomePageList.forEach(ele => {
                            if (ele.coursePrice == null) {
                                ele.coursePrice = 0;
                            }
                            if (ele.courseStudyNum == null) {
                                ele.courseStudyNum = 0;
                            }
                        })
                        this.allWorkTypeList.push(resp.data.data[i]);
                    }
                    this.loadingFlag = false;
                }).catch(err => {

                })

            },
            mouseover(index) {
                this.workTypeList.forEach(function (element, index1) {

                    if (element.flag) {
                        element.flag = false;
                    }

                });
                this.workTypeList[index].flag = true;
            },
            mouseleave() {
                this.workTypeList.forEach(function (element, index1) {
                    if (element.flag) {
                        element.flag = false;
                    }
                });
            },
            mouseover1() {
                this.workTypeList.forEach(function (element, index1) {

                    if (element.flag) {
                        element.flag = false;
                    }
                });
                this.flag1 = true;
            },
            mouseleave1() {
                this.flag1 = false;
            }
        }
    }
</script>

<style scoped>
    div /deep/ .el-carousel__container {
        position: relative;
        height: 100% !important;
    }

    div /deep/ .el-carousel--horizontal {
        height: 100% !important;
        overflow-x: hidden;
    }

    a {
        color: black;
    }

    .md2018040301lty .bt-lf {
        padding-top: 66px;
    }

    .md2018040301lty .bt-line {
        width: 100%;
        height: 1px;
        background: #3d3e3f;
    }

    .md2018040301lty .bt-lf .copyright {
        color: #666;
        margin-left: -4px;
    }

    .md2018040301lty .bt-fr {
        padding-top: 50px;
    }

    .md2018040301lty .bt-fr {
        margin-bottom: 23px;
    }

    .md2018040301lty {
        height: 197px;
    }

    .page-footer {
        background: #282c30;
    }

    .md2018040802lty {
        margin-bottom: -25px;
        width: 100%;
        height: 95px;
    }

    .md-2018040201-lty .pic-box .hd-pic img {
        width: 100%;
        height: 100%;
        vertical-align: middle;
    }

    .font-20 {
        font-size: 20px;
    }

    .md-com-list .md-hd .cusfont {
        font-size: 27px;
        margin-right: 5px;
        vertical-align: middle;
    }

    .cusfont-video:before {
        content: "\e6e8";
    }

    .color-888 {
        color: #888;
    }

    .md-2018040201-lty .pic-box .bd-word .price {
        color: #fd573f;
        font-weight: bold;
    }

    .md-2018040201-lty .pic-box .bd-word .bd-tit {
        font-size: 14px;
        line-height: 20px;
        height: 40px;
        /* text-overflow: ellipsis; */
        overflow: hidden;
        width: 100%;
        /* white-space: nowrap; */
        margin-bottom: 12px;
    }

    a:hover {
        color: #f58f00 !important;
    }

    .md-2018040201-lty .pic-box:hover {
        box-shadow: 0 0px 20px 0px rgb(221 221 221);
        margin-top: -2px;
    }



    .bgcolor-fff {
        background: #fff;
    }

    .md-2018040201-lty .pic-box .bd-word {
        padding: 15px;
        font-size: 12px;
    }

    .course_img {
        position: absolute;
        top: 31%;
        width: 100%;
        text-align: center;
        color: white;
        font-size: 19px;
        font-weight: 400;
        letter-spacing: 8px;
        padding: 0 18px;
    }

    .md-2018040201-lty .pic-box .hd-pic {
        height: 125px;
        position: relative;
    }

    .md-2018040201-lty .pic-box {
        position: relative;
        transition: all .1s ease;
        overflow: hidden;
        width: 224px;
        margin: 0 10px;
        border-radius: 5px;
    }

    .md-2018040201-lty {
        margin: 0 -10px 20px;
    }

    .font-14 {
        font-size: 14px;
    }

    .md-com-list .md-hd {
        padding: 15px 0 15px;
        line-height: 27px;
        overflow: hidden;
    }

    .md2018040302lty .menu-con .item .course-list {
        padding: 10px 20px;
        margin-bottom: 10px;
        height: 281px;
    }

    .md2018040302lty .menu-con .item .course-video {
        height: 152px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .md2018040302lty .menu-con .item .course-video li {
        width: 50%;
        padding: 39px 0 0 28px;
    }

    .md2018040302lty .menu-con .item .course-video li .l-p {
        display: inline-block;
        vertical-align: top;
        width: 120px;
        height: 68px;
        position: relative;
    }

    .md2018040302lty .menu-con .item .course-video li .l-p {
        display: inline-block;
        vertical-align: top;
        width: 120px;
        height: 68px;
    }

    .course_img_min {
        position: absolute;
        top: 34%;
        width: 143px;
        text-align: center;
        color: white;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 8px;
        padding: 0 18px;
        left: -4px;
        height: 22px;
        overflow: hidden;
    }

    .menu-con .item .course-video li {
        width: 50%;
        padding: 39px 0 0 28px;
    }

    .bgcolor-fff {
        background: #fff;
    }

    .menu-con .item .course-video {
        height: 152px;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
    }

    .color-999 {
        color: #999;
    }

    .menu-con .item .course-list .course-item .c-l a {
        margin: 0 15px;
        display: block;
        float: left;
        padding-bottom: 14px;
        padding-top: 15px;
    }

    .menu-con .item .course-list .course-item .c-l a {
        margin: 0 15px;
    }

    .menu-con .item .course-list .course-item>p {
        min-width: 108px;
        background: #eee;
        color: #000;
        border-radius: 14px;
        text-align: center;
        float: left;
        line-height: 28px;
        margin: 28px 0;
        padding: 0 5px;
    }

    .menu-con .item .course-list .course-item .c-l {
        margin-left: 108px;
        padding: 17px 0;
        height: 100%;
    }

    .menu-con .item .course-list .course-item {
        height: 87px;
        border-bottom: 1px solid #eae9e9;
    }

    .menu-con .item .course-list .course-item {
        height: auto !important;
    }

    .menu-con .item .course-list .course-item:last-child {
        border-bottom: 0;
    }

    .menu-con .item .course-list {
        padding: 10px 20px;
        margin-bottom: 10px;
        height: 281px;
    }

    .banner-box .menu-con .item {
        width: 830px;
        height: 440px;
        background: #f6f6f8;
        position: absolute;
        left: 225px;
        top: 0;
        z-index: 100;
        border-right: 1px solid #eee;
        cursor: default;
    }

    i.verflag {
        height: 100%;
        display: inline-block;
        vertical-align: middle;
    }

    .md2018040302lty .banner-box .menu-con .menu-list>li .cusfont {
        position: absolute;
        top: 15px;
        right: -10px;
        font-size: 12px;
    }

    .cusfont {
        height: 9px;
        width: 9px;
        border: 1px sou #999;
        transform: rotate(45deg);
        /* border: 2px solid #999; */
        border-top: 1px solid #999;
        border-right: 1px solid #999;
    }


    .md2018040302lty {
        height: auto !important;
        padding-top: 50px;
        padding-bottom: 40px;
    }

    .container {
        clear: both;
        margin: 0 auto;
        text-align: left;
        width: 1200px;
    }

    .md2018040302lty .banner-box {
        height: 440px;
        box-shadow: 0 0 24px 0 #ccc;
        overflow: hidden;
        border-radius: 8px;
    }

    .md2018040302lty .banner-box .menu-con {
        width: 225px;
        position: relative;
    }

    .md2018040302lty .banner-box .menu-con .menu-list>li {
        background: #292d32;
        height: 55px;
        color: #999;
        padding: 10px 30px;
        font-size: 15px;
        border-bottom: 1px solid #1c252d;
        cursor: pointer;
    }

    li {
        list-style: none;
    }

    .md2018040302lty .banner-box .menu-con .menu-list>li>a {
        display: inline-block;
        width: 100%;
        height: 100%;
        position: relative;
    }

    .color-999 {
        color: #999;
    }

    .pull-left {
        float: left;
    }

    .md2018040302lty .banner-box .banner-con .carousel-area {
        width: 975px;
        height: 334px;
        position: relative;
    }

    .md2018040302lty .banner-box .banner-con .carousel-area .hd {
        position: absolute;
        bottom: 30px;
        right: 40px;
        z-index: 99;
    }

    .md2018040302lty .banner-box .banner-con .carousel-area .direct-btn {
        position: absolute;
        width: 20px;
        height: 44px;
        background: rgba(0, 0, 0, .3);
        left: 0;
        top: 45%;
        z-index: 90;
        text-align: center;
        line-height: 44px;
        color: #fff;
        font-size: 12px;
    }

    .md2018040302lty .banner-box .banner-con .ad-area {
        width: 975px;
        height: 106px;
    }

    .md2018040302lty .banner-box .ad-area .ad-list>li {
        width: 160px;
        height: 73px;
        margin: 17px 0 0 40px;
        padding: 20px;
        float: left;
        border-radius: 5px;
    }

    .md2018040302lty .banner-box .ad-area .ad-r {
        width: 120px;
    }

    .pull-right {
        float: right;
    }

    .text-overflow {
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .color-888 {
        color: #888;
    }
</style>


// WEBPACK FOOTER //
// src/components/train/homePage.vue